// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.delete.RentalManagerUserPropertyDeleteV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyDeleteV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { UserPropertyDeleteV2RequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyDeleteV2WebApiHandler_delete_Args {
  postData: UserPropertyDeleteV2RequestDto;
}

export type RentalManagerUserPropertyDeleteV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyDeleteV2WebApiHandler_delete_Args
>;

/**
 * Delete a property
 */
export const useRentalManagerUserPropertyDeleteV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyDeleteV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDeleteV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyDeleteV2WebApiHandler_delete(args.postData, httpClient),
  });
};
